import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Header from "./components/Header"
import Footer from "./components/Footer"
import Home from "./pages/Home"
import About from "./pages/About"
import Services from "./pages/Services"
import Prices from "./pages/Prices"
import ServiceDetail from "./pages/ServiceDetail"
import Projects from "./pages/Projects"
import Contact from "./pages/Contact"
import NotFound from "./pages/NotFound"
import LanguageRouter from "./components/LanguageRouter"
import ScrollToTop from "./components/ScrollToTop"
import { HelmetProvider } from "react-helmet-async"; // ⬅️ important

function App() {
  const { i18n } = useTranslation()
  const supportedLanguages = ["en", "lv", "ru"]

  return (
      <Router>
        <ScrollToTop />
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <main className="flex-grow-1">
            <Routes>
              <Route path="/" element={<Navigate to={`/${i18n.language}`} replace />} />

              <Route path="/:lang" element={<LanguageRouter supportedLanguages={supportedLanguages} />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="services" element={<Services />} />
                <Route path="services/:serviceId" element={<ServiceDetail />} />
                <Route path="projects" element={<Projects />} />
                <Route path="contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
  )
}

export default App
